var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScrollToTopHover(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_245_140)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.0001 33.375C50.6417 33.375 51.2745 33.5247 51.8481 33.8121L89.3412 52.5587C89.3422 52.5592 89.3433 52.5597 89.3443 52.5602C89.8316 52.8002 90.2667 53.1341 90.6247 53.5427C90.9834 53.9522 91.2575 54.4287 91.4311 54.9446C91.6048 55.4606 91.6747 56.0058 91.6367 56.5489C91.5986 57.0919 91.4535 57.6221 91.2096 58.1088C90.9657 58.5955 90.6279 59.0291 90.2156 59.3846C89.8033 59.7402 89.3248 60.0105 88.8075 60.1802C88.2902 60.3499 87.7445 60.4155 87.2017 60.3733C86.6625 60.3314 86.1368 60.1838 85.6546 59.939L50.0001 42.6118L14.3455 59.939C13.8633 60.1838 13.3376 60.3314 12.7984 60.3733C12.2557 60.4155 11.7099 60.3499 11.1927 60.1802C10.6754 60.0105 10.1969 59.7402 9.78458 59.3846C9.37231 59.0291 9.03448 58.5955 8.79059 58.1088C8.54669 57.6221 8.40155 57.0919 8.36353 56.5489C8.3255 56.0058 8.39534 55.4606 8.56903 54.9446C8.74272 54.4287 9.01682 53.9522 9.37552 53.5427C9.73354 53.134 10.1688 52.8001 10.6562 52.5601C10.6571 52.5596 10.6581 52.5591 10.659 52.5587L48.1521 33.8121C48.7257 33.5247 49.3585 33.375 50.0001 33.375Z",
    fill: "#DEE0E6",
    stroke: "#091E5A",
    strokeWidth: 2,
    strokeLinecap: "square"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_245_140",
    x: -4,
    y: 0,
    width: 108,
    height: 108,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_245_140"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_245_140",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrollToTopHover);
export default __webpack_public_path__ + "static/media/scrollToTopHover.44f367df3bc51d4b1752154b2aefbf25.svg";
export { ForwardRef as ReactComponent };